import { isoDateRegex } from "./regex"

function jsonParserExtension(_: unknown, value: unknown) {
	if (typeof value === "string" && isoDateRegex.test(value)) return new Date(value)
	else return value
}

const trpcTransformer = {
	serialize(data: unknown) {
		return data
	},
	deserialize(data: unknown) {
		if (data === undefined) return undefined
		return JSON.parse(JSON.stringify(data), jsonParserExtension)
	},
}

export default trpcTransformer
